
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import EtirComment from "./Commet/EtirComment";
import { useDispatch, useSelector } from "react-redux";
import { useAddTodoMutation } from "../redux/slices/productApiSlice";

const Baxim = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [addingProductId, setAddingProductId] = useState(null);
  const [cartError, setCartError] = useState(null);

  const { catagory } = useParams();
  const navigate = useNavigate();

  const [addTodo] = useAddTodoMutation();
  const dispatch = useDispatch();

  const { userInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  // Serverdən gələn xətanı istifadəçiyə daha ətraflı göstərmək üçün
  const getErrorMessage = (err) => {
    const serverMessage =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.response?.data?.data?.message ||
      err?.data?.message ||
      err?.data?.error;

    if (serverMessage) {
      return String(serverMessage);
    }

    if (err?.response?.status === 400) {
      return "Göndərilən məlumatlar düzgün deyil. Zəhmət olmasa, yenidən cəhd edin.";
    }

    if (err?.response?.status === 401) {
      return "Bu əməliyyatı yerinə yetirmək üçün hesabınıza daxil olmalısınız.";
    }

    if (err?.response?.status === 403) {
      return "Bu əməliyyatı yerinə yetirmək üçün icazəniz yoxdur.";
    }

    if (err?.response?.status === 404) {
      return "Axtarılan məlumat tapılmadı və ya artıq mövcud deyil.";
    }

    if (err?.response?.status === 409) {
      return "Bu əməliyyat hazırda mümkün deyil. Məlumat artıq dəyişmiş ola bilər.";
    }

    if (err?.response?.status === 429) {
      return "Çox sayda sorğu göndərildi. Bir qədər gözləyib yenidən cəhd edin.";
    }

    if (err?.response?.status >= 500) {
      return "Serverdə texniki problem baş verdi. Zəhmət olmasa, bir qədər sonra yenidən cəhd edin.";
    }

    if (err?.message === "Network Error") {
      return "Serverə qoşulmaq mümkün olmadı. İnternet bağlantınızı və serverin işlək vəziyyətdə olduğunu yoxlayın.";
    }

    if (err?.message) {
      return err.message;
    }

    return "Naməlum xəta baş verdi. Zəhmət olmasa, yenidən cəhd edin.";
  };

  // Məhsulları serverdən yüklə
  const fetchItems = async () => {
    setLoading(true);
    setError(null);
    setCartError(null);

    try {
      let url = `${process.env.REACT_APP_API_BASE_URL}/api/qolbaq/catagory/${catagory}`;

      if (userInfo && userInfo._id) {
        url += `/${userInfo._id}`;
      }

      const res = await axios.get(url);

      if (res.data && Array.isArray(res.data.allQolbaq)) {
        setItems(res.data.allQolbaq);
      } else {
        setItems([]);
      }
    } catch (err) {
      console.error("Məhsullar yüklənərkən xəta baş verdi:", err);

      if (err?.response?.status === 404) {
        setItems([]);
        setError(null);
      } else {
        setError(getErrorMessage(err));
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, [catagory, userInfo?._id]);

  // Yenidən cəhd et
  const handleRetry = () => {
    fetchItems();
  };

  // Səbətə əlavə et
  const handleAddToCart = async (item) => {
    if (!item?._id) {
      setCartError(
        "Məhsulun identifikatoru tapılmadı. Məhsulu səbətə əlavə etmək mümkün deyil."
      );
      return;
    }

    if (item.stock === 0) {
      setCartError(
        `"${item.title}" məhsulu hazırda stokda yoxdur və səbətə əlavə edilə bilməz.`
      );
      return;
    }

    setAddingProductId(item._id);
    setCartError(null);

    try {
      const itemWithDetails = {
        productId: item._id,
      };

      const newTodo = await addTodo(itemWithDetails).unwrap();

      // Redux-a əlavə et
      dispatch({
        type: "product/addTodo",
        payload: newTodo,
      });

      alert("Məhsul uğurla səbətə əlavə edildi.");
    } catch (err) {
      console.error("Məhsul səbətə əlavə edilərkən xəta baş verdi:", err);

      const reason = getErrorMessage(err);

      setCartError(
        `"${item.title}" məhsulunu səbətə əlavə etmək mümkün olmadı.\n\nSəbəb: ${reason}`
      );

      alert(
        `Məhsulu səbətə əlavə etmək mümkün olmadı.\n\nSəbəb: ${reason}`
      );
    } finally {
      setAddingProductId(null);
    }
  };

  // Məhsullar yüklənərkən
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col justify-center items-center px-4 bg-gray-50 dark:bg-gray-900">
        <div className="w-12 h-12 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mb-5"></div>

        <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">
          Məhsullar yüklənir...
        </h2>

        <p className="text-center text-gray-500 dark:text-gray-400 max-w-md">
          {catagory} kateqoriyasındakı məhsullar hazırlanır. Zəhmət olmasa,
          gözləyin.
        </p>
      </div>
    );
  }

  // Məhsullar yüklənərkən xəta baş verdikdə
  if (error) {
    return (
      <div className="min-h-screen flex justify-center items-center px-4 bg-gray-50 dark:bg-gray-900">
        <div className="w-full max-w-xl bg-white dark:bg-gray-800 rounded-3xl shadow-xl p-6 md:p-8 border border-red-200 dark:border-red-900">
          <div className="flex justify-center mb-5">
            <div className="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
              <span className="text-3xl">⚠️</span>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-red-600 dark:text-red-400 text-center mb-3">
            Məhsullar yüklənmədi
          </h2>

          <p className="text-center text-gray-600 dark:text-gray-300 mb-5">
            Məhsullar yüklənərkən xəta baş verdi.
          </p>

          <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-2xl p-4 mb-6">
            <p className="text-sm font-semibold text-red-700 dark:text-red-300 mb-2">
              Xətanın səbəbi:
            </p>

            <p className="text-sm text-red-600 dark:text-red-200 break-words whitespace-pre-wrap">
              {error}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              type="button"
              onClick={handleRetry}
              className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 px-5 rounded-xl transition duration-200"
            >
              Yenidən cəhd et
            </button>

            <button
              type="button"
              onClick={() => navigate(-1)}
              className="flex-1 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-white font-semibold py-3 px-5 rounded-xl transition duration-200"
            >
              Geri qayıt
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-12 px-4">
      <h1
        className="text-3xl font-bold text-center mb-10 text-gray-800 dark:text-white"
        data-aos="fade-up"
      >
        {catagory} kateqoriyası
      </h1>

      {/* Səbətə əlavə etmə zamanı baş verən xəta */}
      {cartError && (
        <div
          className="max-w-3xl mx-auto mb-8 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-2xl p-5"
          data-aos="fade-down"
        >
          <div className="flex items-start gap-3">
            <div className="text-2xl">⚠️</div>

            <div className="flex-1">
              <h3 className="font-bold text-red-700 dark:text-red-300 mb-2">
                Səbətə əlavə etmək mümkün olmadı
              </h3>

              <p className="text-sm text-red-600 dark:text-red-200 whitespace-pre-wrap break-words">
                {cartError}
              </p>
            </div>

            <button
              type="button"
              onClick={() => setCartError(null)}
              className="text-red-500 hover:text-red-700 dark:hover:text-red-300 text-xl"
              aria-label="Xətanı bağla"
            >
              ×
            </button>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-16">
        {items.length > 0 ? (
          items.map((item) => (
            <div
              key={item._id}
              className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-5 transition duration-300 hover:shadow-xl"
              data-aos="fade-up"
            >
              <div className="flex justify-center mb-4 w-full">
                {Array.isArray(item.photo) && item.photo.length > 0 ? (
                  <div className="relative w-full h-60">
                    <img
                      src={item.photo[0]}
                      alt={`${item.title || "Məhsul"} şəkli`}
                      className="object-cover w-full h-full rounded-xl cursor-pointer"
                      onClick={() => navigate(`/product/${item._id}`)}
                    />
                  </div>
                ) : (
                  <div className="w-full h-60 flex items-center justify-center bg-gray-100 dark:bg-gray-700 rounded-xl">
                    <span className="text-gray-400">
                      Məhsul şəkli yoxdur
                    </span>
                  </div>
                )}
              </div>

              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2 text-center">
                {item.title}
              </h3>

              <p className="text-center text-gray-700 dark:text-gray-300 mb-4">
                Qiymət:{" "}
                {item.discountApplied ? (
                  <>
                    <span className="text-red-500 line-through mr-2">
                      {item.originalPrice}₼
                    </span>

                    <span className="text-green-500 font-semibold">
                      {item.price}₼
                    </span>
                  </>
                ) : (
                  <span className="font-semibold">{item.price}₼</span>
                )}
              </p>

              <div className="flex flex-col gap-3">
                <button
                  type="button"
                  onClick={() => navigate(`/product/${item._id}`)}
                  className="bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-4 rounded-lg transition duration-200"
                >
                  Məhsul haqqında
                </button>

                <button
                  type="button"
                  onClick={() => handleAddToCart(item)}
                  disabled={
                    item.stock === 0 || addingProductId === item._id
                  }
                  className={`py-2 px-4 rounded-lg text-white text-center transition duration-200 ${
                    item.stock === 0 || addingProductId === item._id
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-600 hover:bg-blue-700"
                  }`}
                >
                  {addingProductId === item._id ? (
                    <span className="flex items-center justify-center gap-2">
                      <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                      Səbətə əlavə edilir...
                    </span>
                  ) : item.stock === 0 ? (
                    "Stokda yoxdur"
                  ) : (
                    "Səbətə əlavə et"
                  )}
                </button>
              </div>
            </div>
          ))
        ) : (
          <div
            className="text-center col-span-full py-16"
            data-aos="fade-up"
          >
            <div className="max-w-md mx-auto bg-gray-50 dark:bg-gray-800 rounded-3xl p-8">
              <div className="text-5xl mb-4">📦</div>

              <h2 className="text-xl font-bold text-gray-800 dark:text-white mb-2">
                Məhsul tapılmadı
              </h2>

              <p className="text-gray-500 dark:text-gray-300 mb-6">
                Bu kateqoriyada hazırda göstəriləcək məhsul yoxdur.
              </p>

              <button
                type="button"
                onClick={handleRetry}
                className="bg-indigo-600 hover:bg-indigo-700 text-white py-2.5 px-6 rounded-xl transition duration-200"
              >
                Yenidən yoxla
              </button>
            </div>
          </div>
        )}
      </div>

      <EtirComment />
    </div>
  );
};

export default Baxim;
